import React from 'react';

import cx from 'classnames';

import styles from './Chip.module.scss';

/**
 * @description UI Component to display Chip.
 *
 * @author  Swapnil Misal <@swapnil.misal>
 *
 * @param props props of the component
 * @param props.variant variant of the Chips eg. info, success, warning and error.
 * @param props.bordered add border to the chip
 * @param props.children children passed to component
 * @returns {React.component}
 */

interface IChipProps {
	variant: string;
	className?: string;
	children: React.ReactNode;
	bordered?: boolean;
}

const Chip = ({
	variant = 'info',
	className = '',
	children,
	bordered = false,
}: IChipProps) => {
	return (
		<div
			className={cx(
				styles.chip,
				styles[variant],
				{ [styles.border]: bordered },
				className,
			)}
		>
			{children}
		</div>
	);
};

export default Chip;
